import {gql} from "@apollo/client";

export const authorizeUser = gql`
    mutation AuthorizeUser($userId: Int!, $token: String!) {
        authorizeUser(userId: $userId, token: $token)
    }
`